import React, { useRef, useContext, useState, useEffect } from 'react'
import PopoverMenu from 'js/components/ui/PopoverMenu.js';
import IconButton from '@mui/material/IconButton';
import { Link, useNavigate } from "react-router-dom";
import AppContext from 'js/Contexts/App.js';
import { produce } from 'immer';
import 'scss/components/page-components/Layout/Navbar/SettingsDropdown.scss';
import { useTranslate2 } from 'js/components/helpers/Translate.js';

const SettingsDropdown = (props) => {
    const appContext = useContext(AppContext);
    const triggerRef = useRef();
    const [hasDeveloperAccess, setHasDeveloperAccess] = useState(false);
    const [accessChecked, setAccessChecked] = useState(false);
    let currentUser = appContext.authService.getCurrentIdentity()?.user;
    const currentAccount = appContext.appReducer.getCurrentAccountWithData();
    
    useEffect(() => {
        const checkDeveloperAccess = async () => {
            if (currentAccount?.id) {
                const hasRightSubscription = await appContext.AccountSubscriptionService.hasAnyAccountSubscription(currentAccount.id, ['godmode', 'developer-account']);
                if (hasRightSubscription) {
                    setHasDeveloperAccess(true);
                }
                else{
                    setHasDeveloperAccess(false);
                }
            } else {
                setHasDeveloperAccess(false);
            }
            setAccessChecked(true);
        };
        checkDeveloperAccess();
    }, [currentAccount?.id]);
    
    const closeDropDown = () => {
        appContext.setMainLayoutState(produce(appContext.mainLayoutState, draft => {
            draft.settingsDropdownOpen = false;
        }));
    };

    const { layoutTranslations } = appContext;
    const translate = useTranslate2(layoutTranslations?.translations || {});

    return (
        <div className="L_Navbar_SettingsDropdown">
            <div className="menuTrigger" ref={triggerRef} onClick={() => {
                appContext.setMainLayoutState(produce(appContext.mainLayoutState, draft => {
                    draft.settingsDropdownOpen = !appContext.mainLayoutState.settingsDropdownOpen;
                }));
            }}>
                <IconButton aria-label="settings" size="small">
                    <img src="/icon/layout/gear.svg" className="gearIcon" />
                </IconButton>
            </div>
            
            {appContext.mainLayoutState.settingsDropdownOpen && accessChecked &&
                <PopoverMenu onClose={closeDropDown} className="L_Navbar_SettingsMenu" open={true} anchorEl={triggerRef.current} placement={'bottom-end'}>
                    <h3>{translate('Navbar.SystemSettings')}</h3>
                    <div className="menuList">
                        <div className="menuItem">
                            <Link onClick={closeDropDown} to="/a/me/display-language">
                                <img src="/icon/layout/language-icon.svg" /> {translate('Navbar.DisplayLanguage')}
                            </Link>
                        </div>
                        {hasDeveloperAccess && (
                            <div className="menuItem">
                                <Link to={"a/ac/" + currentAccount?.id + "/developer-apps"} onClick={() => { closeDropDown(); }} className="viewAllUsersLink">
                                    <img src="/icon/layout/code-icon.svg"  /> {translate('Navbar.DeveloperApps')}
                                </Link>
                            </div>
                        )}
                    </div>
                </PopoverMenu>
            }
        </div>
    )
}

export default SettingsDropdown
